// Dividend snowball: the income of the held lines over ten years, with and
// without reinvesting it. Pure, computed by code from GET /plan/dividends.
//
// - the dividend per share grows by `growth` % a year;
// - reinvested dividends buy more of the same income at the current yield
//   (prices assumed to grow with the dividends, so the yield stays put);
// - an optional monthly deposit is invested at the same yield.

export const MILESTONES = [
  { id: 'streaming', label: 'Votre abonnement de streaming est payé', yearly: 15 * 12 },
  { id: 'coffee', label: 'Votre café du matin est payé', yearly: 2.5 * 365 },
  { id: 'phone', label: 'Votre forfait et votre box sont payés', yearly: 50 * 12 },
  { id: 'groceries', label: 'Vos courses du mois sont payées', yearly: 400 * 12 },
  { id: 'rent', label: 'Un loyer est payé', yearly: 900 * 12 },
];

const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));

// growthOf keeps the observed growth within a sensible range (a few years of
// history are noisy) and defaults to 3 %.
export const growthOf = (pct) => (pct === null || pct === undefined || !Number.isFinite(Number(pct)) ? 3 : clamp(Number(pct), -5, 10));

export const snowball = ({ income, yieldPct, growth = 3, years = 10, monthlyDeposit = 0 }) => {
  const g = growth / 100;
  const y = (yieldPct || 0) / 100;
  const rows = [];
  let withReinvest = income;
  let without = income;
  for (let year = 1; year <= years; year += 1) {
    const added = withReinvest * y + monthlyDeposit * 12 * y;
    withReinvest = withReinvest * (1 + g) + added;
    without = without * (1 + g) + monthlyDeposit * 12 * y;
    rows.push({ year, reinvested: Math.round(withReinvest * 100) / 100, spent: Math.round(without * 100) / 100 });
  }
  return rows;
};

// milestonesOf tells, for each milestone, the year the reinvested income
// first covers it (0 = already today, null = not within the horizon).
export const milestonesOf = (income, rows) => MILESTONES.map((m) => {
  if (income >= m.yearly) return { ...m, year: 0 };
  const hit = rows.find((r) => r.reinvested >= m.yearly);
  return { ...m, year: hit ? hit.year : null };
});
